$(function() {

	function cartNotification() {
	
		$('.j-cart-notification').addClass('active');

		setTimeout(function(){

			$('.j-cart-notification').removeClass('active');

		}, 3000);

	};

	

	// Toggle flavour variants
	$(document).on('click', '.flavour-list a', function(e){
	
		e.preventDefault();
		$(this).addClass('active').siblings().removeClass('active');
		var bgcolor = $(this).css('background-color')
		var flavour_color = bgcolor.replace('rgb', 'rgba').replace(')', ',0.2)');
		$('.product-template').css('background', 'linear-gradient(to bottom, '+ flavour_color + ', #fff 1000px)');

	});


	// Set cost per serving on load

	var cps = $('.j-id').find('option:selected').data('cost-per-serving');
	$('.j-update-cps').text(cps);

	$('.shopify-product-form').each(function(){

		console.log('each reached');
		var first_price = $(this).find('.j-id').find('option:selected').data('price');
		$(this).find('.j-variant-price').text(first_price);


	});

	// var first_price = $('.j-id').find('option:selected').data('price');
	// $('.j-variant-price').text(first_price);

	// Main select ID filter

	// function append_tp_reviews(sku){
	// 	$('.product-reviews').append("<div class=\"tp-wrapper\"></div>");
	// 	$('.tp-wrapper').html("<div class=\"trustpilot-widget\" data-locale=\"en-GB\" data-template-id=\"54d39695764ea907c0f34825\" data-businessunit-id=\"5db30d76705460000174cfd9\" data-style-height=\"24px\" data-style-width=\"100%\" data-theme=\"light\" data-sku=\"1231232"+sku+"\"><a href=\"https://uk.trustpilot.com/review/highfive.co.uk\" target=\"_blank\" rel=\"noopener\">Trustpilot</a></div>");
	// }

 //    function reload_js(src) {
 //        $('script[src="' + src + '"]').remove();
 //        $('<script async>').attr('src', src).appendTo('head');
 //    }	

	$(document).on('filter', '.j-id', function() {

		//console.log('EVENT FIRED');

		$(this).find('option').prop('disabled', true);

		// var skuFilter = $(this).data('variant-sku') ? '' + $(this).data('variant-sku') + '' : '';

		var sizeFilter = $(this).data('filtered-size') ? '[data-size=' + $(this).data('filtered-size') + ']' : '';
		var flavourFilter = $(this).data('filtered-flavour') ? '[data-flavour=' + $(this).data('filtered-flavour') + ']' : '';

		$(this).find('option' + flavourFilter).prop('disabled', false);

		$(this).closest('form').find('.size-list a').addClass('disabled').find('.j-variant-price').text('Sold Out');

		$(this).find('option[data-sold-out]').prop('disabled', true);

		$(this).find('option' + flavourFilter + sizeFilter + ':enabled:first').prop('selected', true);

		$(this).find('option:enabled').each(function() {

			$(this).closest('form').find('.size-list a[data-size=' + $(this).data('size') + ']').removeClass('disabled').find('.j-variant-price').text($(this).data('price'));
			
		});

		$(this).closest('form').find('.size-list a[data-size='+$(this).find('option:selected').data('size') + ']').addClass('active').siblings().removeClass('active');

		// Get selected option cost per serving and update
		var cps = $(this).find('option:selected').data('cost-per-serving');
		//console.log('Cost per serving: ' + cps);
		$(this).closest('form').find('.j-update-cps').text(cps);

		// Get selected option price and update
		var vprice = $(this).find('option:selected').data('price');
		$(this).closest('form').find('.j-update-compare-at-price').text(vprice);

		// Get selected option compare-at-price and update
		var vcompareprice = $(this).find('option:selected').data('compare-at-price');
		//console.log('Variant compare at price: ' + vcompareprice);
		$(this).closest('form').find('.j-update-price').text(vcompareprice);

		var vsize = $(this).find('option:selected').data('size-human');
		//console.log('Variant size: ' + vsize);
		$(this).closest('form').find('.j-change-size').text(vsize);

		var vflavour = $(this).find('option:selected').data('flavour-human');
		$(this).closest('form').find('.j-change-flavour').text(vflavour);

		var variant_value = $(this).find('option:selected').val();
		//console.log('Final value: ' + variant_value);
		$(this).closest('form').find('.add-to-cart-btn').val(variant_value);

		var variant_img = $(this).find('option:selected').data('variant-img');

		console.log(variant_img);

		$('.j-p-carousel .item[data-img-src="' + variant_img + '"]').click();

		// Start trade discount logic

		if ( $(this).hasClass('hasTradeDiscount') ){

			$(this).find('option:enabled').each(function() {

				var vprice_value = $(this).data('variant-price');
				var discount = $(this).data('trade-discount');
				var discountedPrice = vprice_value - (vprice_value * (discount / 100));
				var discountedPriceValue = ( discountedPrice / 100 ).toFixed(2);
				$(this).closest('form').find('.size-list a[data-size=' + $(this).data('size') + ']').find('.j-variant-price').text('£' + discountedPriceValue);

			});

			var active_trade_price = $('.j-select-size.active .j-variant-price').text();
			console.log('Active trade price: ' + active_trade_price);
			$('.j-update-compare-at-price').text(active_trade_price);

		}


		if ( $(this).closest('form').find('.size-list a').length == 1 ){

			if ( $(this).closest('form').find('.size-list a').hasClass('disabled') ){

				$(this).closest('form').find('.add-to-cart-btn').text('Out of stock').prop('disabled', true).addClass('disabled'); 

			} else {

				$(this).closest('form').find('.add-to-cart-btn').text('Add to basket').prop('disabled', false).removeClass('disabled'); 

			}

		}

	})

	// On variant chnage

	$(document).on('click', '.j-select-size, .j-select-flavour', function(e) {
		e.preventDefault();

		if($(this).data('size')) {
			// filter by size
			$(this).closest('form').find('.j-id').data('filtered-size', $(this).data('size'));
		}

		if($(this).data('flavour')) {
			// filter by flavour
			$(this).closest('form').find('.j-id').data('filtered-flavour', $(this).data('flavour'));
			$(this).closest('form').find('.j-id').data('filtered-size', '');

			// Change slick bg on flavour change

			var slickFlavour = $(this).data('flavour');
			var flavour_rgb = $( '.pf-' + slickFlavour ).css('background-color');

			if ( flavour_rgb !== undefined ){
			
				flavour_rgb.replace('rgb', 'rgba');
				var variant_bg = flavour_rgb.replace('rgb', 'rgba').replace(')', ', 0.1)');
				$(this).closest('.product-item').css( 'background-color', variant_bg );

			}

		}

		$(this).closest('form').find('.j-id').trigger('filter');

	});

	$('.j-select-size:first-child, .j-select-flavour:first-child').trigger('click');


	// Slick product carousel bg set

	$('.product-item .flavour-list').each(function(){

		var slickFlavour = $(this).find('.j-select-flavour').data('flavour');
		var flavour_rgb = $( '.pf-' + slickFlavour ).css('background-color');
		
		if ( flavour_rgb !== undefined ){
			//console.log(flavour_rgb);
			flavour_rgb.replace('rgb', 'rgba');
			var variant_bg = flavour_rgb.replace('rgb', 'rgba').replace(')', ', 0.1)');
			$(this).closest('.product-item').css( 'background-color', variant_bg );
		}


	});



	// Cart JS functions


	$(document).on('click', '.add-to-cart-btn', function(e){

		e.preventDefault();

		var btn 			= $(this);
		var id 			= $(this).val(); // Get product variant ID from variant
		var quantity 	= $(this).closest('.shopify-product-form').find(".j-update-qty").val();

		// console.log(id);
		// console.log(quantity);

		CartJS.addItem(id, quantity, {}, {
		    "success": function(data, textStatus, jqXHR) {

		    	if ( !btn.hasClass('trade-button') ){

		    		$('.j-toggle-cart').trigger('click');

		    	} else {

		    		var url = window.location.href + '?cart=open';

		    		setTimeout(function(){

		    			window.location.replace(url);

		    		}, 1000);

		    	}
		    	
		    	cartNotification();
		    	
		    },
		    "error": function(jqXHR, textStatus, errorThrown) {
		        console.log('Error: ' + errorThrown + '!');
		    }
		});

	});


	$(document).on('click', '.cart_item .qty-selector span', function(){

		var qty_input = $(this).parent().find('input');

        if( $(this).hasClass('minus') ){

            if( qty_input.val() < 2 ){
                console.log('smaller than 0');
            } else {

                var counter = parseInt(qty_input.val());
                counter--;
              	qty_input.val(counter);

            }

            var itemID = $(this).parent().data('vid');
            console.log('quantity item ID: ' + itemID, 'Quantity: ' + counter);
            
            setTimeout(function(){
            	CartJS.updateItemById(itemID, counter);
            }, 500);

        }

        if( $(this).hasClass('plus') ){

            var counter = parseInt(qty_input.val());
            counter++;
            qty_input.val(counter);

            var itemID = $(this).parent().data('vid');
            console.log('quantity item ID: ' + itemID, 'Quantity: ' + counter);
            
            setTimeout(function(){
            	CartJS.updateItemById(itemID, counter);
            }, 500);

        }  

    });

	$(document).on('click', '.j-remove-product', function(e,cart){
	
		e.preventDefault();
		var vid = $(this).data('vid');
		CartJS.removeItemById(vid);
		$(this).closest('.cart_item').fadeOut();
	
	});

	$(document).on('cart.requestComplete', function(event,cart) {
       
        cartRequestComplete();

    });

	function cartRequestComplete() {

    	$('.cart_contents_wrapper').load('/ .cart_contents', function(){

			if ( !$('.add-to-cart-btn').hasClass('trade-button') ){

				$('.site-header').addClass('cart-active');
				$('.j-toggle-cart, .cart-sidebar').addClass('active');

			}

			jQuery.getJSON('/cart.js', function(cart) {
				//$('.j-toggle-cart').text( cart.item_count );
			});

		});

    }

    // Open cart on redirect

    if ( document.location.href.indexOf('cart=open') > -1 ) {

    	//cartRequestComplete();
    	console.log('OPEN CART - URL TRIGGER');
    	$('.j-toggle-cart').click();
        
    }

    $(document).on('click', '.j-add-account-upsell', function(e){
    
    	e.preventDefault();

		var btn 			= $(this);
		var id 			= $(this).data('id'); // Get product variant ID from variant
		var quantity 	= 1;

		// console.log(id);
		// console.log(quantity);

		CartJS.addItem(id, quantity, {}, {
		    "success": function(data, textStatus, jqXHR) {
		        cartNotification();
		    },
		    "error": function(jqXHR, textStatus, errorThrown) {
		        console.log('Error: ' + errorThrown + '!');
		    }
		});

		if ( btn.hasClass('trade-button') ){

    		var url = window.location.href + '?cart=open';

    		setTimeout(function(){

    			window.location.replace(url);

    		}, 1000);

    	}


    
    });

});